import axios from 'axios'
import useSWR from 'swr'

const fetcher = (url: string) => axios.get(url).then((res) => res.data)

export const useCookieConsentDecision = () => {
  const {
    data: existingCookiePreferences,
    error,
    mutate
  } = useSWR('/api/consent_decisions/me/cookies', fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false,
    revalidateOnMount: true,
    // we dont want it to fail, show the popup, then suddenly hide popup again
    shouldRetryOnError: false
  })

  const updateCookieConsentDecision = async (
    userId: number,
    preferences: CookiePreferences
  ) => {
    let updatedPreferences: UpdatedPreferences = {
      valid: false,
      preferences: {
        advertising: false,
        analytical: false,
        essential: false,
        functional: false
      }
    }

    await mutate(async () => {
      try {
        const res = await axios.post('/api/consent_decisions/me/cookies', {
          user_id: userId,
          source: 'cookie_preferences_popup',
          preferences
        })

        updatedPreferences = res.data

        return updatedPreferences
      } catch {
        return { preferences, valid: true }
      }
    })

    return updatedPreferences
  }

  return {
    loading: existingCookiePreferences === undefined && !error,
    existingCookiePreferences,
    error,
    updateCookieConsentDecision,
    mutate
  }
}

type CookiePreferences = {
  advertising: boolean
  analytical: boolean
  essential: boolean
  functional: boolean
}

type UpdatedPreferences = {
  valid: boolean
  preferences: CookiePreferences
}
